import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { EmptyState } from "@/react/components/shared/uikit/EmptyState";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useMigrationModal } from "./MigrationModal";

const i18nRoot = "settings.access_groups.paywall_migration.empty_state";

interface PaywallFormValues {
  currency_id?: number;
  id: number;
  paywall_group_id?: number;
}

export const MigrationEmptyState = ({
  closePaywallFormModal,
}: {
  closePaywallFormModal: () => void;
}) => {
  const { watch } = useFormContext<PaywallFormValues>();
  const paywallId = watch("id");
  const paywallGroupId = watch("paywall_group_id");
  const currencyId = watch("currency_id");

  const migrationModal = useMigrationModal();

  const goToPaywallKnowledgeBase = () => {
    // eslint-disable-next-line sonarjs/link-with-target-blank -- Disabled for plugin version update. Fix when possible
    window.open(
      "https://help.circle.so/p/basics/community-access/access-group-overview",
      "_blank",
    );
  };
  return (
    <div className={classNames("rounded border border-gray-200")}>
      <EmptyState
        header={t([i18nRoot, "header"])}
        description={t([i18nRoot, "description"])}
        primaryLabel={t([i18nRoot, "primary_cta"])}
        secondaryLabel={t([i18nRoot, "secondary_cta"])}
        onPrimaryClick={() => {
          void migrationModal.show({
            paywallId: paywallId,
            closePaywallFormModal,
            paywallGroupId: paywallGroupId,
            currencyId: Number(currencyId),
          });
        }}
        onSecondaryClick={goToPaywallKnowledgeBase}
      />
    </div>
  );
};
